"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StepperField = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _grid = require("@rebass/grid");
var _formik = require("formik");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("../../constants/theme");
var _useIntervalClick = _interopRequireDefault(require("../../hooks/useIntervalClick"));
var _RoundButton = _interopRequireDefault(require("../action/RoundButton"));
var _Min = _interopRequireDefault(require("../figure/Min"));
var _Plus = _interopRequireDefault(require("../figure/Plus"));
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _excluded = ["maximum", "minimum", "disabled", "size", "variant", "nullable", "editable", "validate"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StepperField = exports.StepperField = function StepperField(_ref) {
  var _ref$maximum = _ref.maximum,
    maximum = _ref$maximum === void 0 ? Number.MAX_VALUE : _ref$maximum,
    _ref$minimum = _ref.minimum,
    minimum = _ref$minimum === void 0 ? 0 : _ref$minimum,
    disabled = _ref.disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'outline' : _ref$variant,
    nullable = _ref.nullable,
    editable = _ref.editable,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function (val) {
      return val === null ? undefined : val < minimum ? 'Waarde ligt onder het minimum' : val > maximum ? 'Waarde ligt boven het maximum' : undefined;
    } : _ref$validate,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, Object.assign({}, props, {
    validate: validate
  }), function (_ref2) {
    var _ref2$form = _ref2.form,
      setFieldValue = _ref2$form.setFieldValue,
      setFieldTouched = _ref2$form.setFieldTouched,
      _ref2$field = _ref2.field,
      name = _ref2$field.name,
      value = _ref2$field.value,
      error = _ref2.meta.error;
    return /*#__PURE__*/_react["default"].createElement(Stepper, {
      editable: !!editable,
      disabled: !!disabled,
      nullable: !!nullable,
      value: value,
      maximum: maximum,
      minimum: minimum,
      name: name,
      size: size,
      setValue: function setValue(val) {
        setFieldTouched(name, true, false);
        setFieldValue(name, val, true);
      },
      variant: variant,
      error: error
    });
  });
};
var Stepper = function Stepper(_ref3) {
  var value = _ref3.value,
    setValue = _ref3.setValue,
    minimum = _ref3.minimum,
    maximum = _ref3.maximum,
    name = _ref3.name,
    error = _ref3.error,
    disabled = _ref3.disabled,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'medium' : _ref3$size,
    _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'outline' : _ref3$variant,
    className = _ref3.className,
    nullable = _ref3.nullable,
    editable = _ref3.editable,
    buttonClassName = _ref3.buttonClassName;
  var dispatch = function dispatch(type) {
    return setValue(function () {
      switch (type) {
        case 'increment':
          {
            if (value === null) {
              return minimum;
            }
            var newValue = (value !== null && value !== void 0 ? value : minimum) + 1;
            if (newValue > maximum) {
              return value;
            }
            return newValue;
          }
        case 'decrement':
          {
            var _newValue = (value !== null && value !== void 0 ? value : minimum) - 1;
            if (_newValue < minimum && !nullable) {
              return value;
            }
            if (nullable && _newValue < minimum) {
              return null;
            }
            return _newValue;
          }
        default:
          throw new Error('Stepper: invalid action dispatched');
      }
    }());
  };
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    editMode = _useState2[0],
    setEditMode = _useState2[1];
  var incrementProps = (0, _useIntervalClick["default"])(function () {
    return dispatch('increment');
  });
  var decrementProps = (0, _useIntervalClick["default"])(function () {
    return dispatch('decrement');
  });
  var roundButtonProps = {
    variant: variant,
    size: size,
    roundButtonClassName: buttonClassName
  };
  var inputRef = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(value),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    editableValue = _useState4[0],
    setEditableValue = _useState4[1];
  (0, _react.useEffect)(function () {
    return setEditableValue(value);
  }, [value]);
  var onEditableInputChange = (0, _react.useCallback)(function (event) {
    var newValue = event.currentTarget.value !== '' ? parseInt(event.currentTarget.value, 10) : '';
    if (typeof newValue !== 'number') {
      setEditableValue(newValue);
    }
    if (newValue > maximum || newValue < minimum) {
      return;
    }
    setEditableValue(newValue);
  }, [maximum, minimum]);
  var onEditableValueClick = (0, _react.useCallback)(function () {
    setEditMode(true);
    setTimeout(function () {
      var _inputRef$current;
      return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_grid.Box, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(_RoundButton["default"], Object.assign({
    disabled: nullable ? disabled || value === null : disabled || (value !== null && value !== void 0 ? value : 0) <= minimum
  }, roundButtonProps, decrementProps), /*#__PURE__*/_react["default"].createElement(_Min["default"], null)), editMode && editable && /*#__PURE__*/_react["default"].createElement(_grid.Box, {
    width: "4rem",
    px: 2
  }, /*#__PURE__*/_react["default"].createElement(Input, {
    max: maximum,
    min: minimum,
    ref: inputRef,
    value: editableValue !== null && editableValue !== void 0 ? editableValue : '',
    type: "number",
    onChange: onEditableInputChange,
    onBlur: function onBlur() {
      setEditMode(false);
      if (typeof editableValue === 'number') {
        setValue(editableValue);
      }
    }
  })), !editMode && /*#__PURE__*/_react["default"].createElement(Value, {
    onClick: editable ? onEditableValueClick : undefined,
    disabled: disabled
  }, value === null ? '?' : value), /*#__PURE__*/_react["default"].createElement(_RoundButton["default"], Object.assign({
    disabled: disabled || value === maximum
  }, roundButtonProps, incrementProps), /*#__PURE__*/_react["default"].createElement(_Plus["default"], null))), error && /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], {
    name: name
  }, error));
};
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Stepper__Container",
  componentId: "sc-16h5vwd-0"
})(["display:flex;align-items:center;margin:1rem 0;"]);
var Input = _styledComponents["default"].input.withConfig({
  displayName: "Stepper__Input",
  componentId: "sc-16h5vwd-1"
})(["border-radius:", ";width:100%;text-align:center;background:none;outline:none;font:inherit;border:none;color:currentColor;:focus{box-shadow:0 0 0 1px var(--border-color),inset 0 0 0 1px var(--border-color);--border-color:", ";}::-webkit-outer-spin-button,::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}[type='number']{-moz-appearance:textfield;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.radius.textInput;
}, function (_ref5) {
  var theme = _ref5.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input);
});
var Value = _styledComponents["default"].span.withConfig({
  displayName: "Stepper__Value",
  componentId: "sc-16h5vwd-2"
})(["line-height:1em;width:4rem;text-align:center;color:", ";transition:color 200ms;"], function (_ref6) {
  var disabled = _ref6.disabled,
    theme = _ref6.theme;
  return disabled ? theme.colors.neutral['30'] : 'inherit';
});
var _default = exports["default"] = Stepper;
//# sourceMappingURL=Stepper.js.map